import React from 'react';
import classNames from 'classnames';
import FieldContainer from '../FieldContainer';
import Validation from './Validation';
import styles from './Input.scss';

function Input({
  input, label, type, meta: { touched, error }, customProps = { input: {}, container: {} },
}) {
  return (
    <FieldContainer {...customProps.container}>
      <label className={styles.label} htmlFor={input.name}>{label}</label>
      <Validation
        touched={touched}
        error={error}
        customError={customProps.error ? customProps.error.component : null}
        ignoreOthers={customProps.error && customProps.error.ignoreOthers}
      >
        <input
          {...input}
          {...customProps.input}
          type={type}
          id={input.name}
          className={classNames(
            'ui-input',
            styles.input,
          )}
        />
      </Validation>
    </FieldContainer>
  );
}

export default Input;
